import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui/PageHeader';
import { WarrantyTag } from '../components/ui/WarrantyTag';
import { pricingConfig, warrantyConfig } from '../data/pricing';
import { sceneImages } from '../data/images';
import { useLanguage } from '../contexts/LanguageContext';
import { bundleName } from '../utils/pricing';
import { buttonClasses } from '../utils/buttonStyles';
const commitments = [{
  title: 'Defective on arrival',
  body: 'If a light arrives defective, contact us and we replace it per warranty terms.'
}, {
  title: 'Covered failures',
  body: 'Covered manufacturing defects during the applicable warranty period are resolved with a replacement.'
}, {
  title: 'Real support',
  body: 'A support team that answers — by email, with a clear claim process and order tracking.'
}];
export function Promise() {
  const {
    lang
  } = useLanguage();
  return <>
      <PageHeader image={sceneImages.poolSteps} title={<>
            Built for the Elements. <span className="text-ice" data-id="element-1199" data-mp="21lpd5kmk3wpv">Backed by MarineForceLED.</span>
          </>} lead="Professional-grade lighting deserves professional-grade support." data-id="element-1198" data-mp="kqyu6zzypk9r" />
      <section className="mx-auto max-w-site px-5 py-20 md:px-8 md:py-28" data-id="element-1200" data-mp="2aekew4ctfaaw">
        <dl className="grid gap-12 md:grid-cols-3" data-id="element-1201" data-mp="26e0gkxgia0n6">
          {commitments.map(c => <div key={c.title} className="border-t border-marine/60 pt-6" data-id="element-1202" data-mp="1io644h03me3g">
              <dt className="font-display text-3xl font-semibold uppercase" data-id="element-1203" data-mp="1dpl3whkujuf0">{c.title}</dt>
              <dd className="mt-3 text-titanium" data-id="element-1204" data-mp="1drxv7lchvh4q">{c.body}</dd>
            </div>)}
        </dl>
      </section>

      <section aria-labelledby="coverage-title" className="border-y mf-hairline bg-navy" data-id="element-1205" data-mp="1mqj6qwjjtvw0">
        <div className="mx-auto max-w-site px-5 py-20 md:px-8 md:py-28" data-id="element-1206" data-mp="334j4q1yu3bgm">
          <h2 id="coverage-title" className="font-display text-4xl font-semibold uppercase md:text-5xl" data-id="element-1207" data-mp="336m6tkd9gv1p">
            Coverage by purchase
          </h2>
          <table className="mt-10 w-full max-w-3xl text-left" data-id="element-1208" data-mp="1vstin54i2wmh">
            <tbody data-id="element-1209" data-mp="20r3ezj1yo39o">
              <tr className="border-b mf-hairline" data-id="element-1210" data-mp="20qllgu6oo35g">
                <th scope="row" className="py-4 pr-6 font-medium" data-id="element-1211" data-mp="20pa9i7333p39">Individual lights</th>
                <td className="py-4" data-id="element-1212" data-mp="24t85wa10ylsm"><WarrantyTag tier={warrantyConfig.individual} data-id="element-1213" data-mp="24qlxy9a8249v" /></td>
              </tr>
              {pricingConfig.bundles.filter(b => b.qty > 1).map(b => <tr key={b.id} className="border-b mf-hairline" data-id="element-1214" data-mp="1d2txuufp03ov">
                  <th scope="row" className="py-4 pr-6 font-medium" data-id="element-1215" data-mp="1h2uln5oolr8l">{bundleName(b, lang)}</th>
                  <td className="py-4" data-id="element-1216" data-mp="1m2h01ig8xdiz"><WarrantyTag tier={b.warranty} data-id="element-1217" data-mp="1m1yufv7p1mye" /></td>
                </tr>)}
            </tbody>
          </table>
          <p className="mt-6 max-w-3xl text-sm text-titanium/70" data-id="element-1218" data-mp="1qui80s6dsi37">
            The Promise does not cover accidental damage, misuse, normal wear or excluded circumstances. Full terms on our
            Warranty page.
          </p>
          <div className="mt-10 flex flex-wrap gap-3" data-id="element-1219" data-mp="yaa069bbaoet">
            <Link to="/warranty" className={buttonClasses('secondary')} data-id="element-1220" data-mp="qrslzpshqlfi">Warranty Information</Link>
            <Link to="/warranty-claim" className={buttonClasses('ghost')} data-id="element-1221" data-mp="lvbymxt48b3h">Start a warranty claim</Link>
          </div>
        </div>
      </section>
    </>;
}